<app-loader></app-loader>
<router-outlet />

<div class="add-new-popup" [class.active]="modalService.showModal">
    <app-confirmation-modal
        *ngIf="modalService.showModal"
    ></app-confirmation-modal>
</div>
